import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xxl-stretch" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card p-3 position-relative" }
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building fs-3x text-warning" })
], -1)
const _hoisted_8 = { class: "col mt-5" }
const _hoisted_9 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hotel fs-3x text-primary" })
], -1)
const _hoisted_12 = { class: "col mt-5 ml-1" }
const _hoisted_13 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_16 = { class: "col mt-5" }
const _hoisted_17 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-info px-6 py-8 rounded-2" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fs-3x text-info" })
], -1)
const _hoisted_20 = { class: "col mt-5" }
const _hoisted_21 = { class: "row mt-3 m-0" }
const _hoisted_22 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-primary" })
], -1)
const _hoisted_25 = { class: "col mt-5" }
const _hoisted_26 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-success" })
], -1)
const _hoisted_29 = { class: "col mt-5 ml-1" }
const _hoisted_30 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-primary" })
], -1)
const _hoisted_33 = { class: "col mt-5" }
const _hoisted_34 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success px-6 py-8 rounded-2" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_37 = { class: "col mt-5" }
const _hoisted_38 = { class: "row mt-3 m-0" }
const _hoisted_39 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-danger d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-danger" })
], -1)
const _hoisted_42 = { class: "col mt-5" }
const _hoisted_43 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_46 = { class: "col mt-5 ml-1" }
const _hoisted_47 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-info d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-3x text-info" })
], -1)
const _hoisted_50 = { class: "col mt-5 ml-1" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 col-6 border border-5 border-white-and-rounded d-flex align-items-center px-6 py-8 rounded-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/association-list",
                class: "text-warning fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Association")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.data.total_trainers), 1),
              _createVNode(_component_router_link, {
                to: "/institute-list",
                class: "text-primary fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Institute")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/course-list",
                class: "text-success fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Course")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/bill-list",
                class: "text-info fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Bill")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/map-trainer-institute-list",
                class: "text-primary fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Map Trainer with Institute")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.data.total_trainers), 1),
              _createVNode(_component_router_link, {
                to: "/map-trainer-course-list",
                class: "text-success fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Map Trainer with Course")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/map-assessore-institute-list",
                class: "text-primary fw-bold fs-7 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Map Assessore with Institute")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/map-assessore-course-list",
                class: "text-success fw-bold fs-7 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Map Assessore with Course")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("h4", _hoisted_42, _toDisplayString(_ctx.data.total_assessor), 1),
              _createVNode(_component_router_link, {
                to: "/pending-trainer-list",
                class: "text-danger fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Trainer")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("h4", _hoisted_46, _toDisplayString(_ctx.data.total_trainers), 1),
              _createVNode(_component_router_link, {
                to: "/pending-assessore-list",
                class: "text-success fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Assessor")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("h4", _hoisted_50, _toDisplayString(_ctx.data.total_pending_trainee), 1),
              _createVNode(_component_router_link, {
                to: "/pending-trainee-list",
                class: "text-info fw-bold fs-6 mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending Trainee")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_51
        ])
      ])
    ])
  ]))
}